import React, { useEffect, useState } from 'react';
import { Grid } from '@mui/material';
import YatungPaperLabel from '@Src/_basic/components/YatungPaperLabel';
import { WarehouseData } from '@Src/_basic/object/FeedTroughMaintenanceManagement';
import { useTranslation } from 'react-i18next';

interface Props {
  data: WarehouseData;
}
export default function FeedTroughMaintenanceManagementBody(props: Props) {
  const { t: i18T } = useTranslation();
  const { data } = props;
  const [capacityValue, setCapacityValue] = useState<number>(0);
  const capacityCal = () => {
    const capacity = data.volume * data.specificWeight;
    setCapacityValue(capacity);
  };
  useEffect(() => {
    capacityCal();
  }, [data]);
  const textStyle = {
    fontSize: 24,
    fontFamily: 'Inter',
    fontWeight: 400,
    color: '#7C878E',
    my: 1,
    ml: 3,
  };
  const symbolSmall = {
    fontSize: 20,
    fontFamily: 'Inter',
    fontWeight: 400,
    color: '#7C878E',
    ml: 3,
  };
  const symbolBig = {
    fontSize: 36,
    fontFamily: 'Inter',
    fontWeight: 400,
    color: '#7C878E',
    ml: 3,
  };
  return (
    <>
      <Grid container justifyContent={'flex-start'} item xs={12}>
        <Grid container justifyContent={'flex-start'} item xs={4}>
          <YatungPaperLabel label={i18T('FEEDTROUGHMAINTENANCEMANAGEMENT.TYPE_SETTING')} sx={textStyle} />
        </Grid>
        <Grid container justifyContent={'flex-start'} item xs={4}>
          <YatungPaperLabel label={i18T('FEEDTROUGHMAINTENANCEMANAGEMENT.FEEDTROUGH_NAME')} sx={textStyle} />
        </Grid>
        <Grid container justifyContent={'flex-start'} item xs={4}>
          <YatungPaperLabel label={i18T('FEEDTROUGHMAINTENANCEMANAGEMENT.DEFINITION_NAME')} sx={textStyle} />
        </Grid>
      </Grid>
      <Grid container justifyContent={'flex-start'} item xs={12}>
        <Grid container justifyContent={'flex-start'} item xs={4}>
          <YatungPaperLabel label={data.typeName} sx={textStyle} />
        </Grid>
        <Grid container justifyContent={'flex-start'} item xs={4}>
          <YatungPaperLabel label={data.code} sx={textStyle} />
        </Grid>
        <Grid container justifyContent={'flex-start'} item xs={4}>
          <YatungPaperLabel label={data.name} sx={textStyle} />
        </Grid>
      </Grid>
      <Grid container justifyContent={'flex-start'} item xs={12} sx={{ mt: 5 }}>
        <Grid container justifyContent={'flex-start'} item xs={4}>
          <YatungPaperLabel label={i18T('FEEDTROUGHMAINTENANCEMANAGEMENT.ADD_SPEFICATIONS')} sx={textStyle} />
        </Grid>
      </Grid>
      <Grid container justifyContent={'flex-start'} item xs={12}>
        <Grid container justifyContent={'flex-start'} item xs={4}>
          <YatungPaperLabel label={data.specificationName} sx={textStyle} />
        </Grid>
      </Grid>
      <Grid container justifyContent={'flex-start'} item xs={12} sx={{ mt: 5 }}>
        <Grid container justifyContent={'flex-start'} item xs={4}>
          <YatungPaperLabel label={i18T('FEEDTROUGHMAINTENANCEMANAGEMENT.VOLUME')} sx={textStyle} />
        </Grid>
      </Grid>
      <Grid container justifyContent={'flex-start'} item xs={12} sx={{ ml: 2 }}>
        <Grid container justifyContent={'flex-start'} alignItems={'center'} item xs={4}>
          <Grid container justifyContent={'flex-start'} item xs={3}>
            <YatungPaperLabel sx={symbolSmall} label={i18T('FEEDTROUGHMAINTENANCEMANAGEMENT.M3')} />
          </Grid>
        </Grid>
        <Grid container justifyContent={'flex-start'} alignItems={'center'} item xs={4}>
          <Grid container justifyContent={'flex-start'} item xs={4}>
            <YatungPaperLabel label={i18T('FEEDTROUGHMAINTENANCEMANAGEMENT.SPECIFIC_GRAVITY')} sx={symbolSmall} />
          </Grid>
        </Grid>
      </Grid>
      <Grid container justifyContent={'flex-start'} item xs={12}>
        <Grid container justifyContent={'flex-start'} alignItems={'center'} item xs={4}>
          <Grid container justifyContent={'center'} item xs={5}>
            <YatungPaperLabel label={data.volume ? data.volume : 0} sx={textStyle} />
          </Grid>
          <Grid container justifyContent={'center'} item xs={7}>
            <YatungPaperLabel sx={symbolBig} label={i18T('FEEDTROUGHMAINTENANCEMANAGEMENT.TAKE')} />
          </Grid>
        </Grid>
        <Grid container justifyContent={'flex-start'} alignItems={'center'} item xs={4}>
          <Grid container justifyContent={'center'} item xs={6}>
            <YatungPaperLabel label={data.specificWeight ? data.specificWeight : 0} sx={textStyle} />
          </Grid>
          <Grid container justifyContent={'center'} alignItems={'center'} item xs={2}>
            <YatungPaperLabel label={i18T('FEEDTROUGHMAINTENANCEMANAGEMENT.EQAL')} sx={symbolBig} />
          </Grid>
        </Grid>
        <Grid container justifyContent={'flex-start'} alignItems={'center'} item xs={4}>
          <Grid container justifyContent={'center'} item xs={6}>
            <YatungPaperLabel label={capacityValue} sx={textStyle} />
          </Grid>
          <Grid container justifyContent={'center'} item xs={4}>
            <YatungPaperLabel label={i18T('FEEDTROUGHMAINTENANCEMANAGEMENT.TON')} sx={textStyle} />
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}
